import React from 'react';
import { motion } from 'framer-motion';
import { Instagram } from 'lucide-react';
const videos = ['https://cdn.magicpatterns.com/uploads/u3Zxm4cZQH9NvududX1Fmq/instasaved-08-06-2026 (3).mp4', 'https://cdn.magicpatterns.com/uploads/6nfEhWcEe7FUr39vym6MzZ/instasaved-08-06-2026 (6).mp4', 'https://cdn.magicpatterns.com/uploads/3FEYRavuqjbirciSQ6cfmV/instasaved-08-06-2026 (9).mp4', 'https://cdn.magicpatterns.com/uploads/5krzcUqHLYfbNfd24S3FDm/instasaved-08-06-2026 (7).mp4', 'https://cdn.magicpatterns.com/uploads/kruhSm5ykdmZqMAmeUrByF/instasaved-08-06-2026 (8).mp4', 'https://cdn.magicpatterns.com/uploads/pwBdLJVxFLonNBNJvFScJs/instasaved-08-06-2026 (5).mp4'];
export function Gallery() {
  return <section id="galeria" className="py-24 bg-dark" data-id="element-95">
      <div className="container mx-auto px-6" data-id="element-96">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6" data-id="element-97">
          <div data-id="element-98">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-4xl md:text-5xl font-bold mb-4" data-id="element-99">
              Nuestros <span className="text-gold" data-id="element-100">Trabajos</span>
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-gray-400" data-id="element-101">
              Un vistazo a la experiencia Prince.
            </motion.p>
          </div>

          <motion.a initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} href="https://instagram.com/princebarberstudio" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-6 py-3 rounded-full border border-white/10 hover:border-gold/50 transition-colors group" data-id="element-102">
            <Instagram className="text-pink-500 group-hover:text-gold transition-colors" size={20} data-id="element-103" />
            <span className="font-medium text-sm" data-id="element-104">
              Seguinos @princebarberstudio
            </span>
          </motion.a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4" data-id="element-105">
          {videos.map((src, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="relative aspect-[9/16] rounded-sm overflow-hidden group border-2 border-transparent hover:border-gold transition-colors duration-300" data-id="element-106">
              <video src={src} autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-107" />
              <div className="absolute inset-0 bg-transparent md:bg-black/20 group-hover:bg-transparent transition-colors duration-300" data-id="element-108"></div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}